const timeFormat = new Intl.DateTimeFormat('hu-HU', { hour: '2-digit', minute: '2-digit' });
const dayFormat = new Intl.DateTimeFormat('hu-HU', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  weekday: 'long',
});

export const formatTime = (iso: string): string => timeFormat.format(new Date(iso));

export const formatDay = (iso: string): string => {
  const date = new Date(iso);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  if (isSameDay(date, today)) return 'Ma';
  if (isSameDay(date, yesterday)) return 'Tegnap';
  return dayFormat.format(date);
};

export const isSameDay = (a: Date, b: Date): boolean =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

export const dayKey = (iso: string): string => new Date(iso).toISOString().slice(0, 10);
